module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay"
  }, [_c('div', [_c('div', {
    staticClass: "overlay-container"
  }, [_c('mdl-spinner'), _vm._v(" "), _c('h6', [_vm._v("Joining Game")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-216717d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/game/JoiningGameOverlay.vue
// module id = 416
// module chunks = 1